<!-- Breadcrumb -->
<ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="">Home</a>
    </li>
    <li class="breadcrumb-item">Minha Conta</li>
    <li class="breadcrumb-item active">
      Demonstrativo IRRF
    </li>
  </ol>
<!-- //.Breadcrumb -->

<h2 class="titulo-interna">Demonstrativo IRRF</h2>

<form autocomplete="off" method="GET" id="frmListarDemonstrativos" name="frmListarDemonstrativos"
 class="form-horizontal">
 
  <div *ngIf="!haRegistros">
    <div class="alert alert-danger col-sm-12">
        <span>{{ this.msgNotificacaoNenhumPremio }}</span>
    </div>
  </div>
 
  <div *ngIf="haRegistros">

    <div class="alert alert-primary col-sm-12">
         <span>{{ this.msgInfoAnoCalendario }}</span>
    </div> 
    <div class="row" *ngIf="MensagemErro">
      <div class="col-sm-12">
        <div class="alert alert-danger breakline" role="alert">{{MensagemErro}}</div>
      </div>
    </div>
    
    <table class="col-md-3" aria-describedby="Informação Demonstrativo">
       <thead>
        <tr>          
           <th>Baixar Demonstrativo</th>            
        </tr>
       </thead>
      <tbody> 
        <tr *ngFor="let item of demonstrativos; let i = index">                   
          <td style="text-align: left; vertical-align: middle; padding-bottom: 8px;" >            
            <button type="button" class="btn btn-primary" (click)="baixar(item.anoCalendario)" title="{{ this.msgInfoAnoCalendario }}">              
              Ano-Calendário {{item.anoCalendario}} <i class="fa fa-download" aria-hidden="true"></i>
            </button>
            
          </td>
        </tr>
      </tbody>
    </table>

  </div>
  
</form>


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-demonstrativo-imposto-renda/consumidor-demonstrativo-imposto-renda.component.html